import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import CategoriesLeftPanel from "../../components/categories-left-panel/categories-left-panel.component";
import useGetCategories from "../../api/categories";
import CategoriesRightPanel from "../../components/categories-right-panel/categories-right-panel.component";

import './categories-page.styles.scss';



export default function CategoriesPage() {
    const { state, dispatch } = useContext(Context);
    const [activeCategory, setActiveCategory] = useState("");

    const getCategories = useGetCategories();

    useEffect(() => {
        (async () => {
            const categories = await getCategories();
            dispatch({ type: 'SET_CATEGORIES', categories: categories });
        })();
    }, []);

    useEffect(() => {
        setActiveCategory(state.activeCategory);
    }, [state.activeCategory]);


    return (
        <div className={"container-fluid"}>
            <div className="row mt-4">
                <CategoriesLeftPanel />
                {activeCategory && <CategoriesRightPanel category={activeCategory} /> }
            </div>
        </div>
    )
}
